import { useUploadVaxFileMutation } from 'api/glob.api.js';
import { useDispatch } from 'react-redux';
import { formActions } from 'store/vaxFormDataSlice';

const useUploadVaxFile = () => {
	const dispatch = useDispatch();
	const [uploadVaxFile] = useUploadVaxFileMutation();

	const uploadFile = (formData, filename) => {
		dispatch(
			formActions.upload({
				filename,
				src: URL.createObjectURL(formData.get('vaxFile')),
			})
		);
		uploadVaxFile({
			body: formData,
			onProgress: (e) => {
				dispatch(
					formActions.uploadStatus({
						total: e.total,
						loaded: e.loaded,
						filename,
					})
				);
			},
			filename,
		})
			.unwrap()
			.then((result) => {
				dispatch(formActions.uploadFinished(result));
			})
			.catch((e) => {
				console.log('catch vax file upload', e);
				dispatch(formActions.uploadError({ filename: filename, error: e }));
				return e;
			});
	};
	return uploadFile;
};

export default useUploadVaxFile;
